import { FC, useState } from 'react';
import EfButton from '@elem/ui/ef-button';
import EfImg from 'elem/ui/ef-img';
import EfTab from 'elem/ui/ef-tab';
import { useRouter } from 'next/router';
import styled from './index.module.scss';
import { getDetailList, IActive } from './config';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { getIsLogin } from '@/utils/cookie';
import { signupCookie } from '@/utils/cookies/signupCookie';

type ITabItem = {
    type: IActive;
    title: string;
    tips: string;
};
const SeriesTab: FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('tradein.seriestab');
    const [active, setActive] = useState<IActive>('delta');
    const [tips, setTips] = useState('seriestab1_tips');
    const { imgUrl, productOffList, message } = getDetailList(active, locale);
    const router = useRouter();
    const isLogin = getIsLogin();

    let tabList: ITabItem[] = [
        {
            type: 'delta',
            title: t('seriestab1'),
            tips: 'seriestab1_tips',
        },
        {
            type: 'river',
            title: t('seriestab2'),
            tips: 'seriestab2_tips',
        },
        {
            type: 'solar',
            title: t('seriestab3'),
            tips: 'seriestab3_tips',
        },
        {
            type: 'smart',
            title: t('seriestab4'),
            tips: 'seriestab4_tips',
        },
        {
            type: 'others',
            title: t('seriestab5'),
            tips: 'seriestab5_tips',
        },
    ];

    const handleChange = (item: any) => {
        setActive(item.type);
        setTips(item.tips);
    };

    const handleTradeIn = () => {
        // 清除表单页缓存数据
        sessionStorage.removeItem('tradein-data');
        if (isLogin) {
            router.push('/trade-in-online');
        } else {
            signupCookie?.({
                sector_name: t('series_button'),
                entry_position: 4,
            });
            router.push(`/login?redirect=${encodeURIComponent(`/${locale}/trade-in`)}`);
        }
    };

    return (
        <div className={styled.SeriesTab}>
            <div className="tradein-spaec"></div>
            <div className="ef-container">
                <EfTab items={tabList} activeType={active} onChange={handleChange} />
                <p className="series-tips">
                    {t.rich(tips, {
                        i: (text: string) => <span>{text}</span>,
                    })}
                </p>
                <div className="series-box">
                    <ul className="series-productlist">
                        <li>
                            <span>{t('series_product')}</span>
                            <span>{t('series_value')}</span>
                        </li>
                        {productOffList.map((item, index) => (
                            <li key={index}>
                                <span>{item.name}</span>
                                <span>
                                    {t('series_upto')}&nbsp;
                                    {item.value}
                                </span>
                            </li>
                        ))}
                    </ul>
                    <div className="series-img">
                        <EfImg pc={imgUrl} />
                        {message && <p>{message}</p>}
                    </div>
                </div>
                <EfButton onClick={handleTradeIn} theme="black" type="buy_now">
                    {t('series_button')}
                </EfButton>
            </div>
        </div>
    );
};

export default SeriesTab;
